// React
import React, { useEffect, useState } from "react";
import "./index.scss";
import SingleSelect from "../../components/UI/SingleSelect";

// external
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/fontawesome-free-solid";

import { FormattedMessage } from "react-intl";
import Tooltippy from "react-tooltip";

// Constants
import * as Constants from "../../constants";
// Bootstrap
import { Row, Col, Table } from "react-bootstrap";

export default function EntityPortal({
  data,
  userDetails,
  selectedCustomFilters,
  customFilters,
  loginStates,
}) {
  const [dropdownItems, setDropdownItems] = useState([]);
  const [memberShipLink, setMemberShipLink] = useState(
    userDetails && userDetails[0].externalId
      ? `https://sacorporatemembership.tfaforms.net/7?ContactID=${userDetails[0].externalId}`
      : ""
  );
  const [renewMemberShipLink, setRenewMemberShipLink] = useState(
    userDetails && userDetails[0].externalId
      ? `https://sacorporatemembership.tfaforms.net/9?ContactID=${userDetails[0].externalId}`
      : ""
  );
  let membershipSpots = 0;
  const staffInd = loginStates?.login?.data?.staff;
  let isComplimentaryMember = "N";
  if (loginStates?.login?.data?.userDetails.length > 0) {
      let userdetailsCopy = loginStates.login.data.userDetails;
      userdetailsCopy = userdetailsCopy.sort((a, b) => {
        if (
          a.organizationName?.toLowerCase() < b.organizationName?.toLowerCase()
        ) {
          return -1;
        }
        if (
          a.organizationName?.toLowerCase() > b.organizationName?.toLowerCase()
        ) {
          return 1;
        }
        return 0;
      });
      const contactType = userdetailsCopy[0]?.contactType || "";
	    if (contactType.toLowerCase() === "complimentary individual member") {
		      isComplimentaryMember = "Y";
	    }
	}
	 

  const detailsObject = {
    organizationName: data?.[0]?.organizationName,
    organizationLevel: data?.[0]?.organizationLevel,
    emr: data?.[0]?.emr,
    membershipTier: data?.[0]?.membershipTier,
    membershipStartDate: data?.[0]?.membershipStartDate,
    membershipEndDate: data?.[0]?.membershipEndDate,
  };
  const cimUniqList = [];
  data.forEach((item) => {
    if (item.emra && (item.emra.email || item.emra.fullName)) {
      detailsObject.emra = `${item.emra.fullName} (${
        item.emra.email ? item.emra.email : ""
      })`;
    }
    if (
      item.billingContact &&
      (item.billingContact.email || item.billingContact.fullName)
    ) {
      detailsObject.billingContact = `${item.billingContact.fullName} (${
        item.billingContact.email ? item.billingContact.email : ""
      })`;
    }
    if (data?.[0]?.membershipTier === Constants.TIER4) membershipSpots = 10;
    else if (data?.[0]?.membershipTier === Constants.TIER3) membershipSpots = 7;
    else if (data?.[0]?.membershipTier === Constants.TIER2) membershipSpots = 5;
    else if (data?.[0]?.membershipTier === Constants.TIER1) membershipSpots = 2;

    if (item.cimUniqList && item.cimUniqList.length > 0) {
      item.cimUniqList.forEach((listItem) => {
        cimUniqList.push(listItem);
      });
      detailsObject.memberNum = `${
        cimUniqList.length
      } of  ${membershipSpots} spots have been assigned`;
      detailsObject.cimUniqList = cimUniqList;
    } else {
      detailsObject.memberNum = `${
        cimUniqList.length
      } of  ${membershipSpots} spots have been assigned`;
      detailsObject.cimUniqList = cimUniqList;
    }
  });
  useEffect(() => {
    if (userDetails && userDetails.length > 1) {
      const filteredItem = userDetails.map((item) => {
        return {
          ...item,
          value: item.internalId,
          label: item.organizationName,
        };
      });
      const filterDuplcateData = filteredItem
        .filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.internalId === value.internalId)
        )
        .sort((a, b) => {
          if (a.label.toLowerCase() < b.label.toLowerCase()) {
            return -1;
          }
          if (a.label.toLowerCase() > b.label.toLowerCase()) {
            return 1;
          }
          return 0;
        });
      setDropdownItems(filterDuplcateData);
    }
  }, [userDetails]);

  useEffect(() => {
    if (customFilters.organizationvalue) {
      const filterdDetails = userDetails.find(
        (useritem) =>
          useritem.internalId === Number(customFilters.organizationvalue)
      );
      setMemberShipLink(
        `https://sacorporatemembership.tfaforms.net/7?ContactID=${filterdDetails.externalId}`
      );
      setRenewMemberShipLink(
        `https://sacorporatemembership.tfaforms.net/9?ContactID=${filterdDetails.externalId}`
      );
    }
  }, [customFilters.organizationvalue]);

  const infoIcontextItems = [
    "Clicking this button will take you to a link where you can update who the EMR, EMRA, or",
    "Billing Contact are for your entity membership. You can also add or remove the",
    "complimentary IEEE SA individual members (CIMs) associated with your entity membership",
    "tier.",
    "",
    "If you want to update the EMR, EMRA, or Billing Contact, select that option from the menu,",
    "supply the requested information, and submit.",
    "",
    "If you want to remove a CIM, select CIM from the menu. A list of your entity’s current CIMs",
    "will be displayed. Scroll down to the person you wish to remove and select the “remove”",
    "option below that person’s record.",
    "",
    "If you want to add a CIM, select CIM from the menu. A list of your entity’s current CIMs will be",
    "displayed. Scroll down to the end of your CIM roster and select “add another response.”",
    "Supply the requested information and submit.",
  ];

  const renewMembershipText = [
    "Use this link to submit the Membership Renewal form.",
  ];


  return (
    <div className="mb-4 mt-4">
      <div className="clearfix"></div>
      <div className="tab-content ballots common-tab">
        <div className="clearfix"></div>
        <div className="tab-pane active">
          <div className="panel common-tab-panel">
            <div className="border-block" id="tab-content">
              <div className="container-fluid sponsor-group">
                <Row>
                  {dropdownItems && dropdownItems.length > 1 ? (
                    <Col md={6} className="custom-single-select">
                      <SingleSelect
                        label={"Organization "}
                        options={dropdownItems}
                        name="organizationvalue"
                        selectedCustomFilters={selectedCustomFilters}
                      />
                    </Col>
                  ) : (
                    <DetailsSection
                      label="Organization"
                      className="spanstyle1"
                      value={
                        detailsObject ? detailsObject.organizationName : ""
                      }
                    />
                  )}
                  <DetailsSection
                    label="EMR"
                    className="emrStle"
                    className2="whiteSpaceStyle"
                    value={detailsObject ? detailsObject.emr : ""}
                  />
                </Row>
                {/* <Row>
                  <DetailsSection
                    label="Membership Type"
                    className="spanstyle1"
                    value={detailsObject ? detailsObject.organizationLevel : ""}
                  />
                  <DetailsSection
                    label="EMRA"
                    className="emrStle"
                    className2="whiteSpaceStyle"
                    value={detailsObject.emra}
                  />
                </Row> */}
                <Row>
                  <DetailsSection
                    label="Membership Tier"
                    className="spanstyle1"
                    value={detailsObject ? detailsObject.membershipTier : ""}
                  />
                  <DetailsSection
                    label="EMRA"
                    className="emrStle"
                    className2="whiteSpaceStyle"
                    value={detailsObject.emra}
                  />
                </Row>
                <Row>
                  <DetailsSection
                    label="Membership Renewal Date"
                    className="spanstyle1"
                    value={detailsObject ? detailsObject.membershipEndDate : ""}
                  />

                  <DetailsSection
                    label="Billing Contact"
                    className="emrStle"
                    className2="whiteSpaceStyle"
                    value={detailsObject.billingContact}
                  />
                </Row>
                <Row>
                  <Col md={12} className="mb-2 mt-2">
                    <p className="paragraphstyle mb-0">
                      Complimentary IEEE SA individual memberships are a 
                      benefit of your entity membership and offer your employees a means to 
                      participate and represent themselves in the individual-based 
                      standards activities within the IEEE SA.
                    </p>
                  </Col>
                </Row>

                <Row>
                  <DetailsSection
                    label="Complimentary Members"
                    className="spanstyle1"
                    value={detailsObject ? detailsObject.memberNum : ""}
                  />
                  {detailsObject?.cimUniqList?.length > 0 && (
                    <Col md={6} className="text-align-margin">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Email</th>
                          </tr>
                        </thead>
                        <tbody>
                          {detailsObject.cimUniqList.map((item, idx) => (
                            <tr key={`ent${idx}`}>
                              <td>{item.fullName} </td>
                              <td>{item.email} </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </Col>
                  )}
                  {/* {detailsObject && detailsObject.cimUniqList && (
                    <Col md={12} className="text-align-margin">
                      {detailsObject.cimUniqList.map((item, idx) => {
                        return (
                          <span key={idx}>
                            {`${item.fullName}   (${item.email})${
                              detailsObject.cimUniqList.length > 0 &&
                              idx < detailsObject.cimUniqList.length - 1
                                ? ","
                                : ""
                            }`}{" "}
                          </span>
                        );
                      })}
                    </Col>
                  )} */}
                </Row>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
        {(staffInd?.toLowerCase() === "n" && isComplimentaryMember?.toLowerCase() === "n") &&(
          <div className="enity-title-name">
            <strong style={{ display: "flex" }}>
              <a className="tileHeading" href={memberShipLink} target="_blank">
                Manage Membership
                {/* <span className="tooltiptext">
                  "Use this link to update any information about your member
                  contacts (EMR, EMRA, Billing Contact) or to update your
                  complimentary individual members."
                </span> */}
              </a>
              <div className="info-btn ml-1">
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  data-tip
                  data-for="memberInfo"
                  size="sm"
                  color="#333333"
                />
                <Tooltippy
                  id="memberInfo"
                  place="right"
                  effect="solid"
                  textColor="#333333"
                  multiline={true}
                  className="entity-custom-toolTip"
                  clickable
                >
                  {infoIcontextItems.map((item, idx) => (
                    <p className={item ? "mb-0" : ""} key={`${item}-${idx}`}>
                      {item}
                    </p>
                  ))}
                </Tooltippy>
              </div>
            </strong>
          </div>
        )}
        {(staffInd?.toLowerCase() === "n" && isComplimentaryMember?.toLowerCase() === "n") &&(
          <div className="enity-title-name">
            <strong style={{ display: "flex" }}>
              <a className="tileHeading" href={renewMemberShipLink} target="_blank">
                Renew Membership
              </a>
              <div className="info-btn ml-1">
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  data-tip
                  data-for="renewMemberInfo"
                  size="sm"
                  color="#333333"
                />
                <Tooltippy
                  id="renewMemberInfo"
                  place="right"
                  effect="solid"
                  textColor="#333333"
                  multiline={true}
                  className="entity-custom-toolTip"
                  clickable
                >
                  {renewMembershipText.map((item, idx) => (
                    <p className={item ? "mb-0" : ""} key={`${item}-${idx}`}>
                      {item}
                    </p>
                  ))}
                </Tooltippy>
              </div>
            </strong>
          </div>
        )}
      </div>
      <div className="clearfix"></div>
    </div>
  );
}

function DetailsSection({ label, value, className, className2 }) {
  return (
    <Col md={6}>
      <span className={`col-md-6 ${className}`}>
        <strong> {label ? `${label} : ` : ""} </strong>
      </span>
      <span className={`col-md-6 spanstyle${className2}`}>
        {" "}
        {value ? value : ""}
      </span>
    </Col>
  );
}